import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useConversationCache } from './cache'
import { type ConversationRemoveInput, toResponseError, type ConversationRemoveSuccess } from '@terros/common'

export function useRemoveConversation(): RemoveHookResponse<ConversationRemoveInput> {
  const cache = useConversationCache()
  const mutation = useTantalimMutation<ConversationRemoveInput, ConversationRemoveSuccess>({
    url: '/conversation/remove',
  })

  async function remove(input: ConversationRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearItem(input)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
